import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getListLanguage = (params) => {
    return axios.get(`${backendHost}/api/admin/language`, {params});
};